import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Grammar from './pages/Grammar'
import Conversation from './pages/Conversation'
import Writing from './pages/Writing'
import Assessment from './pages/Assessment'
import Progress from './pages/Progress'
import Vocabulary from './pages/Vocabulary'
import Reading from './pages/Reading'
import Listening from './pages/Listening'
import { motion } from 'framer-motion'

function App() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      
      <Box component="main" sx={{ flexGrow: 1, pt: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/grammar" element={<Grammar />} />
            <Route path="/conversation" element={<Conversation />} />
            <Route path="/writing" element={<Writing />} />
            <Route path="/vocabulary" element={<Vocabulary />} />
            <Route path="/reading" element={<Reading />} />
            <Route path="/listening" element={<Listening />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/progress" element={<Progress />} />
          </Routes>
        </motion.div>
      </Box>
      
      {/* Footer */}
      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: 'background.paper',
          borderTop: 1,
          borderColor: 'divider',
          textAlign: 'center',
          color: 'text.secondary'
        }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          © 2024 English Teacher Assistant – Empower Your Future with English.<br></br>
          Powered by LIGO Edu (TT Quế, Kim Bảng, Hà Nam).
        </motion.div>
      </Box>
    </Box>
  )
}

export default App